import { css, styled } from "@sourceful/shared-components";
import { SanityImageGallerySection } from "@sourceful/shared-types";
import { BasePageSection } from "../BasePageSection";
import ImageGallery from "@components/imageGallery";
import { getSanityImgUrl } from "@lib/sanity";

const Wrapper = styled("div", {
  margin: "0 auto",
});

const sectionOverrideStyles = css({
  "&": {
    paddingTop: "clamp(10px, 3vw, 60px)",
    paddingBottom: "clamp(10px, 3vw, 60px)",
    paddingLeft: "0",
    paddingRight: "0",
  },
  "& .section-text-block": {
    padding: "clamp(10px, 3vw, 60px)",
  },
});

interface ImageGallerySectionProps {
  section: SanityImageGallerySection;
}

export const ImageGallerySection = ({ section }: ImageGallerySectionProps) => {
  const images = section?.images || [];
  return (
    <BasePageSection section={section} maxWidth={"1400px"} className={sectionOverrideStyles()}>
      <Wrapper>
        <ImageGallery
          flicketyOptions={{
            autoPlay: section.autoplay,
          }}
          images={images.map(img => {
            return {
              id: img.asset._ref,
              src: getSanityImgUrl(img.asset._ref, base => base.height(350).width(350)),
              alt: img?.metadata?.caption || img.asset._ref,
            };
          })}
        />
      </Wrapper>
    </BasePageSection>
  );
};

export default ImageGallerySection;
